import 'angular:locale/data:fr';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "fr";
